import { render, staticRenderFns } from "./JdsLink.vue?vue&type=template&id=1d59e132&scoped=true&"
import script from "./JdsLink.vue?vue&type=script&lang=ts&"
export * from "./JdsLink.vue?vue&type=script&lang=ts&"
import style0 from "./JdsLink.vue?vue&type=style&index=0&id=1d59e132&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d59e132",
  null
  
)

export default component.exports